import { useSelector } from 'react-redux'
import config from 'config'

import { getLocaleSelector, getMpvid } from '~/app/store/config'
import { queryRatings } from '~/app/features/Gallery/queries/queryRatings'
import { useQuery } from '@tanstack/react-query'

export const useRatingsAndReviews = (mpv?: string) => {
  const locale = useSelector(getLocaleSelector)
  const mpvId = useSelector(getMpvid)

  const { data, isLoading } = useQuery(
    queryRatings(locale, mpv || mpvId, {
      enabled: !!config.tenant && !!locale && (!!mpvId || !!mpv),
      staleTime: Infinity,
      retry: false,
    }),
  )

  return {
    data,
    isLoading,
  }
}
